'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var jsxRuntime = require('react/jsx-runtime');
var styled = require('@emotion/styled');
var coreRenderer = require('@tempi/core-renderer');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const InputText = (props) => {
  const _a = props, {
    commonStyle,
    inputStyle,
    placeholder,
    register,
    name,
    id,
    type = "text"
  } = _a, rest = __objRest(_a, [
    "commonStyle",
    "inputStyle",
    "placeholder",
    "register",
    "name",
    "id",
    "type"
  ]);
  const getPattern = (type2) => {
    if (type2 === "email")
      return coreRenderer.PATTERN_VALIDATION.email;
    if (type2 === "tel")
      return coreRenderer.PATTERN_VALIDATION.phone;
  };
  return /* @__PURE__ */ jsxRuntime.jsx(Wrapper, {
    commonStyle,
    id,
    children: /* @__PURE__ */ jsxRuntime.jsx(StyledInput, __spreadValues({
      inputStyle,
      placeholder,
      type
    }, register ? register(name, __spreadValues({ pattern: getPattern(type) }, rest)) : __spreadValues({ name }, rest)))
  });
};
const Wrapper = styled__default["default"].div(
  ({ commonStyle }) => `
  overflow: hidden;
  ${coreRenderer.getStyle(commonStyle)}
`
);
const StyledInput = styled__default["default"].input(
  ({ inputStyle }) => `
    position: relative;
    display: inline-block;
    width: 100%;
    min-width: 100%;
    color: rgba(0, 0, 0, 0.85);
    height: 100%;
    padding: 0 0.5rem;
    &:focus,
    &-focused {
      outline: 0;
    }
    &::-moz-placeholder {
      opacity: 1;
    }

    &::placeholder {
      color: #999;
    }

    &:placeholder-shown {
      text-overflow: ellipsis;
    }
    border-style: solid;
    border-color: rgb(238, 238, 238);
    border-width: 1px;
  ${coreRenderer.getStyle(inputStyle)}
`
);

exports.InputText = InputText;
